/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountSummaryVo from './AccountSummaryVo';
import CompanyBaseVo from './CompanyBaseVo';
import FragmentResVo from './FragmentResVo';
import IdNameVo from './IdNameVo';




  /**
   * The FragmentDetailVo model module.
   * @module course_standard/model/FragmentDetailVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>FragmentDetailVo</code>.
   * @alias module:course_standard/model/FragmentDetailVo
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>FragmentDetailVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/FragmentDetailVo} obj Optional instance to populate.
   * @return {module:course_standard/model/FragmentDetailVo} The populated <code>FragmentDetailVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'required')) {
        obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'company')) {
        obj['company'] = CompanyBaseVo.constructFromObject(data['company']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'knowledge')) {
        obj['knowledge'] = IdNameVo.constructFromObject(data['knowledge']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'html')) {
        obj['html'] = ApiClient.convertToType(data['html'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'resList')) {
        obj['resList'] = ApiClient.convertToType(data['resList'], [FragmentResVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'createAccount')) {
        obj['createAccount'] = AccountSummaryVo.constructFromObject(data['createAccount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'modifyAccount')) {
        obj['modifyAccount'] = AccountSummaryVo.constructFromObject(data['modifyAccount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 媒体资源类型 0,文字，1:视频；2音频，3:视频音频
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 必学
   * @member {Boolean} required
   */
  exports.prototype['required'] = undefined;
  /**
   * 上传碎片的院校
   * @member {module:course_standard/model/CompanyBaseVo} company
   */
  exports.prototype['company'] = undefined;
  /**
   * 课程目标知识点id
   * @member {module:course_standard/model/IdNameVo} knowledge
   */
  exports.prototype['knowledge'] = undefined;
  /**
   * 标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 摘要
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 内容
   * @member {String} html
   */
  exports.prototype['html'] = undefined;
  /**
   * @member {Array.<module:course_standard/model/FragmentResVo>} resList
   */
  exports.prototype['resList'] = undefined;
  /**
   * @member {module:course_standard/model/AccountSummaryVo} createAccount
   */
  exports.prototype['createAccount'] = undefined;
  /**
   * @member {module:course_standard/model/AccountSummaryVo} modifyAccount
   */
  exports.prototype['modifyAccount'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 最后修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


